import React from 'react';
import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import LazyLoad from '../../../components/common/lazy-load/LazyLoad';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';

export function Card({title, imgUrl, overview, isMobile, readMore}) {
    const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];
    return (
        <AspectRatioCard aspectRatio={'4x3'} key={imgUrl}>
            <div data-slot={'figure'} className="media-flex media-flex--left">
                <LazyLoad offset={offset}>
                    <img className="img-circle" src={imgUrl} />
                </LazyLoad>
            </div>
            <div className="media-flex__content" data-slot={'content'}>
                <div className="media-flex__body">
                    <h4 className="no-margin">{title}</h4>
                </div>
                <div className="media-flex__footer">{overview}</div>
                <div> {readMore} </div>
            </div>
        </AspectRatioCard>
    );
}
